var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ticket-bottom-div" }, [
      _c("a", { attrs: { target: "_blank", href: "/ticket-vue/about" } }, [
        _vm._v("工单系统")
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("by")]),
      _vm._v(" "),
      _c("a", { attrs: { target: "_blank", href: "//www.itaojin.cn" } }, [
        _vm._v("淘金你我")
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("@2021")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48c987ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48c987ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketBottom.vue
// module id = 764
// module chunks = 75